import { render, staticRenderFns } from "./CustomInterval.ts.vue?vue&type=template&id=56ec4f74"
import script from "./CustomInterval.ts.vue?vue&type=script&lang=ts"
export * from "./CustomInterval.ts.vue?vue&type=script&lang=ts"
import style0 from "./CustomInterval.ts.vue?vue&type=style&index=0&id=56ec4f74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports